import React from 'react';
import { ProfileOutlined } from 'jl-design-system/components/icons/ProfileOutlined';
import styles from './account-button.scss';
import { NotificationDot } from '../notification-dot/NotificationDot';

interface AccountButtonProps {
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  greeting?: string;
  myAccountUrl?: string;
  hasNotification?: boolean;
}

export const AccountButton = ({
  onClick,
  greeting,
  myAccountUrl,
  hasNotification,
}: AccountButtonProps) => {
  const label = `Go to your account${hasNotification ? ', new notification' : ''} `;
  return (
    <a
      className={styles.accountButton}
      href={myAccountUrl || '/my-account'}
      onClick={onClick}
      data-test="account-button"
      data-testid="account-button"
      aria-label={label}
    >
      {greeting && <span className={styles.greeting}>{greeting}</span>}
      {hasNotification && <NotificationDot hideLg />}
      <ProfileOutlined
        className={styles.icon}
        dataTestId="account-button-icon"
        size="large"
        title={label}
      />
    </a>
  );
};
